<template>
    <div>
        <router-view> </router-view>
    </div>
</template>

<script>
export default{
    name: 'portal-page',
    components: {},
    data(){
        return {
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/pages/Portal.vue